import './components/nav.js';
import './components/modal.js';
import './components/video.js';
import './components/animations.js';
import './components/accordion.js';
import './components/change-color.js';
